export const WALLET_BASE_PATH = '/pruwallet';
export const WALLET_AWARD_PATH = '/award';
export const WALLET_ASSIGNED_AWARD_PATH = '/assigned-award';
export const WALLET_BULKUPLOAD_PATH = '/bulk-upload';
export const WALLET_BULKUPLOAD_UPLOAD_PATH = '/upload';
export const WALLET_BULKUPLOAD_UPLOAD_AWARD_PATH = '/award';
export const WALLET_BULKUPLOAD_UPLOAD_CREDIT_PATH = '/credit';
export const WALLET_BULKUPLOAD_UPLOAD_STATUS_PATH = '/status';
export const WALLET_CREDIT_PATH = '/credit';

//  These constants map to aside menu, header menu to display title
export const WALLET_TITLE = 'title.wallet';
export const WALLET_AWARD_TITLE = 'title.wallet.award';
export const WALLET_ASSIGNED_AWARD_TITLE = 'title.wallet.assignedAward';
export const WALLET_BULKUPLOAD = 'title.wallet.bulkUpload';
export const WALLET_BULKUPLOAD_UPLOAD = 'title.wallet.bulkUpload.upload';
export const WALLET_BULKUPLOAD_UPLOAD_AWARD = 'title.wallet.bulkUpload.upload.award';
export const WALLET_BULKUPLOAD_UPLOAD_CREDIT = 'title.wallet.bulkUpload.upload.credit';
export const WALLET_BULKUPLOAD_UPLOAD_STATUS = 'title.wallet.bulkUpload.status';
export const WALLET_CREDIT_TITLE = 'title.wallet.bulkUpload.upload.credit';

//  These constants map to permission control, identical to permission enum defined below
export const WALLET_AWARD_NAMESPACE = 'WALLET-AWARD';
export const WALLET_ASSIGNED_AWARD_NAMESPACE = 'WALLET-ASSIGNED-AWARD';
export const WALLET_BULKUPLOAD_UPLOAD_AWARD_NAMESPACE = 'WALLET-BULKUPLOAD-UPLOAD-AWARD';
export const WALLET_BULKUPLOAD_UPLOAD_STATUS_NAMESPACE = 'WALLET-BULKUPLOAD-UPLOAD-STATUS';
export const WALLET_BULKUPLOAD_UPLOAD_CREDIT_NAMESPACE = 'WALLET-BULKUPLOAD-UPLOAD-CREDIT';
export const WALLET_CREDIT_NAMESPACE = 'WALLET-CREDIT';

export enum AdminWalletPermissionType {
  WALLET_AWARD_READ = 'READ_ANY_WALLET-AWARD',
  WALLET_AWARD_CREATE = 'CREATE_ANY_WALLET-AWARD',
  WALLET_AWARD_UPDATE = 'UPDATE_ANY_WALLET-AWARD',
  WALLET_AWARD_APPROVE = 'APPROVE_ANY_WALLET-AWARD',

  //assigned award
  WALLET_ASSIGNED_AWARD_READ = 'READ_ANY_WALLET-ASSIGNED-AWARD',
  WALLET_ASSIGNED_AWARD_CREATE = 'CREATE_ANY_WALLET-ASSIGNED-AWARD',
  WALLET_ASSIGNED_AWARD_UPDATE = 'UPDATE_ANY_WALLET-ASSIGNED-AWARD',

  // bulk upload
  WALLET_BULKUPLOAD_UPLOAD_AWARD_CREATE = 'CREATE_ANY_WALLET-BULKUPLOAD-UPLOAD-AWARD',
  WALLET_BULKUPLOAD_UPLOAD_AWARD_READ = 'READ_ANY_WALLET-BULKUPLOAD-UPLOAD-AWARD',
  WALLET_BULKUPLOAD_UPLOAD_AWARD_UPDATE = 'UPDATE_ANY_WALLET-BULKUPLOAD-UPLOAD-AWARD',
  WALLET_BULKUPLOAD_UPLOAD_CREDIT_CREATE = 'CREATE_ANY_WALLET-BULKUPLOAD-UPLOAD-CREDIT',
  WALLET_BULKUPLOAD_UPLOAD_CREDIT_READ = 'CREATE_ANY_WALLET-BULKUPLOAD-UPLOAD-CREDIT',
  WALLET_BULKUPLOAD_UPLOAD_CREDIT_UPDATE = 'CREATE_ANY_WALLET-WALLET-BULKUPLOAD-UPLOAD-CREDIT',

  // bulk upload status
  WALLET_BULKUPLOAD_STATUS_READ = 'READ_ANY_WALLET-BULKUPLOAD-UPLOAD-STATUS',
  WALLET_BULKUPLOAD_STATUS_APPROVE = 'APPROVE_ANY_WALLET-BULKUPLOAD-UPLOAD-STATUS',

  // credit history
  WALLET_CREDIT_READ = 'READ_ANY_WALLET-CREDIT',
}
